import { render, staticRenderFns } from "./ModelSelectListRenderer.vue?vue&type=template&id=12b54fc6&scoped=true"
import script from "./ModelSelectListRenderer.vue?vue&type=script&lang=js"
export * from "./ModelSelectListRenderer.vue?vue&type=script&lang=js"
import style0 from "./ModelSelectListRenderer.vue?vue&type=style&index=0&id=12b54fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b54fc6",
  null
  
)

export default component.exports